import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { enum_api_uri } from "../../../utils/enum";
import { useAuthStore } from "../../../../../console/store/useAuthStore";
import axiosInstance from "../../axiosInstance";

interface WordCategory {
    event_category_idx: number;
    event_name: string;
}

export interface WordData {
    word_idx: number;
    wreath_word: string;
    search_word: string;
    status: boolean;
    category: WordCategory;
}

interface GetWordResponse {
    limit: number;
    current_page: number;
    start_page: number;
    max_page: number;
    last_page: number;
    end_page: number;
    total_count: number;
    data_list: WordData[];
}

export const useGetWord = (page: number, pageSize: number, search?: string, searchtxt?: string): UseQueryResult<GetWordResponse, Error> => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useQuery<GetWordResponse, Error>({
        queryKey: ["getWordList", page, pageSize, search, searchtxt],
        queryFn: async () => {
            const encodedSearchTxt = encodeURIComponent(searchtxt || "");
            const response = await axiosInstance.get(
                `${enum_api_uri.get_word}?page=${page}&limit=${pageSize}&search=${search}&searchtxt=${encodedSearchTxt}`,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                },
            );
            return response.data.data;
        },

        placeholderData: prevData => {
            if (prevData) {
                return {
                    ...prevData,
                    current_page: page,
                };
            }
            return undefined;
        },
        // staleTime: 300000, // 캐싱 시간 (5분)
    });
};
